import styled from 'styled-components'

export const Navbar = styled.ul`
  list-style: none;
  display: flex;
  align-items: center;
  height: 100%;
`
export const Option = styled.li`
  margin-right: 40px;
  height: 100%;
  display: flex;
  align-items: center;
  color: #363636;
  font-family: Roboto,sans-serif;
  font-size: 16px;
  cursor: pointer;
  position: relative;

  :hover {
    color: #A82827;

    ::before {
      content: "";
      bottom: 0;
      left: -2px;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      background-color: #A82827;
      display: block;
      height: 4px;
      position: absolute;
      width: calc(100% + 8px);
    }
  }
`
